import RequesterTable from './RequesterTable';

export default RequesterTable;
